import { useAuthContext } from '../../adminlogin/useAuthContext';
import { useStudentContext } from "./useStudentContext";
import API_URL from '../../api/APIUrl';
import { Link } from 'react-router-dom';

const StudentRow = ({ id, code, firstname, surname, city, sub_caste, email, admin_status, student_whatsapp, createdAt,total_fees, arranged_amount, payment_deadline }) => {
    const { dispatch } = useStudentContext();
    const { adminuser } = useAuthContext();

    return (
        <tr>
            <td>{code}</td>
            <td>
                <strong>{firstname} {surname}</strong> <br />
                {/* <span className="text-muted">{city}</span> */}
            </td>
            <td>{email}</td>
            <td>{student_whatsapp}</td>

            <td>{new Date(createdAt).toLocaleDateString()}</td>
            <td>{new Date(payment_deadline).toLocaleDateString()}</td>
            <td>{total_fees - arranged_amount}</td>
            <td>
                {admin_status}
            </td>
            <td>
                <div className="d-flex flex-column gap-2">
                    <Link to={`/admin/view-application/${id}`} className="btn btn-primary btn-sm" target="_blank">
                        🔍 View Application
                    </Link>

                    {/* <Link to={`/admin/view-documents/${id}`} className="btn btn-info btn-sm" target="_blank">
                        📄 View Documents
                    </Link> */}

                    <Link to={`/admin/process-application/${id}`} className="btn btn-success btn-sm" target="_blank">
                        ✏️ Update Status
                    </Link>
                </div>
            </td>
        </tr>
    );
}

export default StudentRow;
